//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  doLogout,
  queryCheckIdentifyStatus,
  queryNeedCheckIdentify,
  querySfxsbmxx,
  queryUserInfo,
  uploadPhoto,
} from '@/https/user'
import TMenu from '@/TShareComponent/TMenu'
import iconLogo from '@/assets/img/my-logo.png'
import iconInfo from '@/assets/img/icon_info.png'
import iconEditPassword from '@/assets/img/icon_edit_password.png'
import iconLoginOff from '@/assets/img/icon_login_off.png'
import iconMoney from '@/assets/img/icon_money.png'
import logoBg from '@/assets/img/my_bg.png'
import { confirm } from '@/utils/dialog'
import { danger } from '@/utils/notify'

export default {
  components: { TMenu },

  data () {
    return {
      logoBg,
      iconLogo,
      userData: {},
      uploadList: [],
      menuList: [
        {
          title: '缴费记录',
          link: '/myOwnPay',
          icon: iconMoney,
        },
        {
          title: '我的二维码',
          link: '/myQrcode',
          icon: iconInfo,
        },
        {
          title: '修改密码',
          link: '/modifyPassword',
          icon: iconEditPassword,
        },
        {
          title: '退出登录',
          icon: iconLoginOff,
          handler: () => this.logOutLogin(),
        },
      ],
    }
  },

  computed: {},

  async created () {
    this.getUserData()
    this.setEnrollInfo()
    this.setIdentify()
  },

  methods: {
    uploadPhoto,

    async setIdentify () {
      const { data } = await queryNeedCheckIdentify()

      if (+data === 1) {
        this.menuList.splice(2, 0, {
          title: '身份核验',
          icon: iconInfo,
          noClick: true,
          link: '/checkIdentify',
          handler: () => this.handlerCheckIdentify(),
        },)
      }
    },

    async setEnrollInfo () {
      const { data } = await querySfxsbmxx()

      if (+data === 1) {
        this.menuList.splice(0, 0, {
          title: '报名信息',
          link: '/myOwnEnroll',
          icon: iconInfo,
        },)
      }
    },

    async handlerCheckIdentify () {
      const { code, message } = await queryCheckIdentifyStatus()

      if (+code === 0) {
        this.$router.push('/checkIdentify')
      } else {
        danger(message)
      }
    },

    async getUserData () {
      const { data } = await queryUserInfo()
      this.userData = data || {}
    },

    filterHandlerMenu (menu) {
      if (menu.handler) {
        menu.handler()
      }
    },

    async logOutLogin () {
      confirm({
        title: '提示',
        message: '您确定退出登录吗？',
        beforeConfirm: async (done) => {
          const { code, message } = await doLogout()

          if (+code === 0) {
            done()
            this.$router.replace('/')
          } else {
            danger(message)
          }
        },
      })
    },
  },
}
